module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_da_danish-90f7d12042a18708f7ed68f9984c6ee1.svg";